export class BluetoothService {
  startListeningForHeartRateDataOn() {
      return Promise.resolve();
  }

  stopListeningForHeartRateData() {
    return Promise.resolve();
  }

  setRetryPolicy() {
  }
}
